module.exports = __webpack_public_path__ + "img/save-arrow.ca6ba929.svg";